import { ReactNode, useMemo } from "react";
import TaskState from "@coworker/apprestructured/src/task-management/types/TaskState";
import styles from "./ViewerTop.module.css";
import SheetTop from "@coworker/apprestructured/src/task-management/components/SheetTop/SheetTop";

type ViewerTopProps = {
  state?: TaskState | undefined;
  children: ReactNode;
  className?: string | undefined;
};

function ViewerTop({ state, children, className }: ViewerTopProps) {
  const stateClassName = useMemo(() => {
    switch (state) {
      case "pending":
        return styles["pending"];
      case "completed":
        return styles["completed"];
      case "closed":
        return styles["closed"];
      default:
        return styles["pending"];
    }
  }, [state]);

  return (
    <SheetTop className={`${stateClassName} ${className}`}>{children}</SheetTop>
  );
}

export default ViewerTop;
